export default "__VITE_ASSET__DsYVEMqL__"